import { render, staticRenderFns } from "./collectionsList.vue?vue&type=template&id=5150dad0&scoped=true&"
import script from "./collectionsList.vue?vue&type=script&lang=js&"
export * from "./collectionsList.vue?vue&type=script&lang=js&"
import style0 from "./collectionsList.vue?vue&type=style&index=0&id=5150dad0&lang=scss&scoped=true&"
import style1 from "./collectionsList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5150dad0",
  null
  
)

export default component.exports